import { useMemo } from 'react';

import { DateTime } from 'luxon';
import { useCookies } from 'react-cookie';

import { TimeZoneEnums } from '@nhl/nhl-breakaway-ui';

import { CookieName } from '~/core/enums';

type SitePreferences = {
    timezone: TimeZoneEnums | string;
    yearsSeenBracketConfetti: Array<number>;
};

const useSitePreferencesCookie = (): [SitePreferences, (newSitePreferences: SitePreferences) => void] => {
    const [cookies, setCookie] = useCookies([CookieName.SITE_PREFERENCES]);

    const sitePreferencesCookie = useMemo<SitePreferences>(() => {
        if (cookies[CookieName.SITE_PREFERENCES] !== undefined) {
            return cookies[CookieName.SITE_PREFERENCES];
        }

        return {};
    }, [cookies]);

    const setSitePreferencesCookie = (newSitePreferences: SitePreferences) => {
        setCookie(CookieName.SITE_PREFERENCES, newSitePreferences, {
            expires: DateTime.now().plus({ year: 1 }).toJSDate(),
        });
    };

    return [sitePreferencesCookie, setSitePreferencesCookie];
};

export default useSitePreferencesCookie;
